export default "__VITE_ASSET__CNcYQZJs__"